<template>
  <div class="courseSettings">
    <v-tabs centered v-model="tab" dark background-color="transparent" slider-color="primary" class="courseSettings__tabs">
      <v-tab>Kurse</v-tab>
      <v-tab v-if="false">Bilder</v-tab>
      <v-tab>Kategorisieren</v-tab>
    </v-tabs>

    <v-tabs-items dark v-model="tab" class="transparent">
      <!-- Tab 1: Kurse verwalten -->
      <v-tab-item>
        <v-row no-gutters class="courseSettings__course my-5 px-5">
          <!-- Suche -->
          <v-col cols="12">
            <v-text-field
              dark
              filled
              rounded
              dense
              hide-details
              prepend-inner-icon="mdi-magnify"
              v-model="courseListFilter"
              label="Suche"
              class="courseSettings__search mb-4"></v-text-field>
          </v-col>

          <!-- Neuer Kurs erstellen -->
          <v-col class="d-flex justify-center mb-6" cols="12">
            <v-dialog transition="dialog-bottom-transition" max-width="600">
              <template v-slot:activator="{ on, attrs }">
                <v-btn color="primary" class="courseSettings__action-add-btn" rounded large depressed v-bind="attrs" v-on="on">
                  <v-icon left>mdi-plus</v-icon>
                  Kurs hinzufügen
                </v-btn>
              </template>
              <template v-slot:default="dialogAdd">
                <v-card dark class="courseSettings__dialog-card">
                  <v-toolbar color="primary" dark flat>
                    <v-icon left>mdi-plus-circle-outline</v-icon>
                    <v-toolbar-title>
                      <strong>Neuen Kurs hinzufügen</strong>
                    </v-toolbar-title>
                  </v-toolbar>
                  <div class="pa-5 courseSettings__dialog-content d-flex flex-column">
                    <v-text-field dark filled rounded dense label="Titel" v-model="addCourse.name" class="mb-2"></v-text-field>
                    <v-textarea
                      dark
                      filled
                      rounded
                      auto-grow
                      rows="3"
                      label="Beschreibung"
                      v-model="addCourse.beschreibung"
                      class="mb-2"></v-textarea>
                    <div class="courseSettings__cropper-wrap mb-4">
                      <slim-cropper style="height: 220px" :options="slimOptionsExercise">
                        <img v-if="addCourse.bild" :src="'/img/kurse/' + addCourse.bild" alt="" />
                        <input type="file" accept="image/*" />
                      </slim-cropper>
                    </div>

                    <div class="courseSettings__section-label">Kategorien</div>
                    <v-row dense>
                      <v-col cols="12" md="6" v-for="(value, key) in addCourse.categories" :key="key">
                        <v-select
                          dark
                          filled
                          rounded
                          dense
                          hide-details
                          v-model="addCourse.categories[key]"
                          :items="[1, 2, 3, 4]"
                          :label="capitalize(key)"></v-select>
                      </v-col>
                    </v-row>
                  </div>

                  <v-card-actions class="pa-4 justify-end">
                    <v-btn text rounded @click="dialogAdd.value = false">Abbrechen</v-btn>
                    <v-btn color="primary" rounded depressed @click="createCourse(dialogAdd)">
                      <v-icon left small>mdi-check</v-icon>
                      Speichern
                    </v-btn>
                  </v-card-actions>
                </v-card>
              </template>
            </v-dialog>
          </v-col>

          <!-- Kursliste -->
          <v-col cols="12">
            <transition-group name="course-list" tag="div">
              <v-col
                v-for="(course, index) in courseList"
                :key="course._id"
                cols="12"
                class="courseSettings__course-list py-3 px-4 mb-2"
                :class="{
                  'd-flex': !courseListFilter.length || course.name.toLowerCase().indexOf(courseListFilter.toLowerCase()) !== -1,
                  'd-none': courseListFilter.length && course.name.toLowerCase().indexOf(courseListFilter.toLowerCase()) === -1,
                }">
                <div class="courseSettings__course-list-title d-flex align-center">
                  <v-avatar v-if="course.bild" size="40" class="mr-3">
                    <img :src="'/img/kurse/' + course.bild" alt="" />
                  </v-avatar>
                  <v-avatar v-else size="40" color="primary" class="mr-3">
                    <v-icon dark small>mdi-dumbbell</v-icon>
                  </v-avatar>
                  <span class="my-auto">{{ shorten(course.name) }}</span>
                </div>
                <div class="courseSettings__course-list-action ml-auto d-flex align-center">
                  <v-dialog @input="setEditIndex($event, index)" transition="dialog-bottom-transition" max-width="600">
                    <template v-slot:activator="{ on, attrs }">
                      <v-btn color="red lighten-1" icon small @click="deleteEntry(course, 'course', 0)">
                        <v-icon>mdi-delete-outline</v-icon>
                      </v-btn>
                      <v-btn icon small class="ml-1" color="primary" v-bind="attrs" v-on="on">
                        <v-icon>mdi-pencil-outline</v-icon>
                      </v-btn>
                    </template>
                    <template v-slot:default="dialog">
                      <v-card dark class="courseSettings__dialog-card">
                        <v-toolbar color="primary" dark flat>
                          <v-icon left>mdi-pencil-outline</v-icon>
                          <v-toolbar-title>
                            <strong>{{ shorten(course.name) }}</strong>
                          </v-toolbar-title>
                        </v-toolbar>
                        <div class="pa-5 courseSettings__dialog-content d-flex flex-column">
                          <v-text-field dark filled rounded dense label="Titel" v-model="course.name" class="mb-2"></v-text-field>
                          <v-textarea
                            dark
                            filled
                            rounded
                            auto-grow
                            rows="3"
                            label="Beschreibung"
                            v-model="course.beschreibung"
                            class="mb-2"></v-textarea>
                          <div class="courseSettings__cropper-wrap mb-4">
                            <slim-cropper style="height: 300px" :options="slimOptionsExercise">
                              <img v-if="course.bild" :src="'/img/kurse/' + course.bild" alt="" />
                              <input type="file" accept="image/*" />
                            </slim-cropper>
                          </div>

                          <div class="courseSettings__section-label">Kategorien</div>
                          <v-row dense>
                            <v-col cols="12" md="6" v-for="(value, key) in course.categories" :key="key">
                              <v-select
                                dark
                                filled
                                rounded
                                dense
                                hide-details
                                v-model="course.categories[key]"
                                :items="[1, 2, 3, 4]"
                                :label="capitalize(key)"></v-select>
                            </v-col>
                          </v-row>
                        </div>
                        <v-card-actions class="pa-4 justify-end">
                          <v-btn text rounded @click="dialog.value = false">Abbrechen</v-btn>
                          <v-btn color="primary" rounded depressed @click="updateCourse(course, dialog)">
                            <v-icon left small>mdi-check</v-icon>
                            Speichern
                          </v-btn>
                        </v-card-actions>
                      </v-card>
                    </template>
                  </v-dialog>
                </div>
              </v-col>
            </transition-group>
          </v-col>
        </v-row>
      </v-tab-item>

      <!-- Tab 2: Bilder -->
      <v-tab-item v-if="false">
        <v-row class="course_picture" v-for="(course, index) in courseList" :key="'bild-' + course._id">
          <v-col cols="6">
            <v-img height="200px" width="100%" contain v-if="course.bild" :src="'/img/kurse/' + course.bild"></v-img>
          </v-col>
          <v-col cols="6" class="d-flex">
            <strong class="my-auto">{{ course.name }}</strong>
            <div class="courseSettings__course-list-action action2">
              <v-dialog @input="setEditIndex($event, index)" transition="dialog-bottom-transition" max-width="600">
                <template v-slot:activator="{ on, attrs }">
                  <v-btn color="red" icon @click="deleteEntry(course, 'course', 0)">
                    <v-icon>mdi-delete-outline</v-icon>
                  </v-btn>
                  <v-btn icon class="courseSettings__course-list-action-btn" color="primary" v-bind="attrs" v-on="on">
                    <v-icon>mdi-pencil-outline</v-icon>
                  </v-btn>
                </template>
                <template v-slot:default="dialog">
                  <v-card dark class="courseSettings__dialog-card">
                    <v-toolbar color="primary" dark flat>
                      <v-toolbar-title>
                        <strong>{{ shorten(course.name) }}</strong>
                      </v-toolbar-title>
                    </v-toolbar>
                    <div class="pa-5 courseSettings__dialog-content d-flex flex-column">
                      <v-text-field dark filled rounded dense class="mb-2" label="Titel" v-model="course.name"></v-text-field>
                      <v-textarea dark filled rounded auto-grow rows="3" label="Beschreibung" v-model="course.beschreibung" class="mb-2"></v-textarea>
                      <div class="courseSettings__cropper-wrap">
                        <slim-cropper style="height: 200px" :options="slimOptionsExercise">
                          <img v-if="course.bild" :src="'/img/kurse/' + course.bild" alt="" />
                          <input type="file" accept="image/*" />
                        </slim-cropper>
                      </div>
                    </div>
                    <v-card-actions class="pa-4 justify-end">
                      <v-btn text rounded @click="dialog.value = false">Abbrechen</v-btn>
                      <v-btn color="primary" rounded depressed @click="updateCourse(course, dialog)">Speichern</v-btn>
                    </v-card-actions>
                  </v-card>
                </template>
              </v-dialog>
            </div>
          </v-col>
        </v-row>
      </v-tab-item>

      <!-- Tab 3: Kategorisieren -->
      <v-tab-item>
        <v-row no-gutters class="courseSettings__course my-5 px-5">
          <v-col cols="12">
            <v-text-field
              dark
              filled
              rounded
              dense
              hide-details
              prepend-inner-icon="mdi-magnify"
              v-model="courseListFilter"
              label="Suche"
              class="courseSettings__search mb-4"></v-text-field>
          </v-col>
          <v-col cols="12" v-for="(course, index) in filteredCourses" :key="'cat-' + course._id">
            <course-categories
              :index="index"
              :course="course"
              @save-categories="handleSaveCategories"
              @delete-course="handleDeleteEntry"
              @edit-course="handleEditCourse" />
          </v-col>
        </v-row>
      </v-tab-item>
    </v-tabs-items>

    <!-- Delete Dialog -->
    <v-dialog v-model="deleteDialog" persistent max-width="360">
      <v-card dark class="courseSettings__dialog-card">
        <v-card-title class="text-h6 pt-5">
          <v-icon color="red lighten-1" left>mdi-alert-circle-outline</v-icon>
          {{ shorten(deleteDialogTitle, 25) }}
        </v-card-title>
        <v-card-text v-if="deleteDialogPreText" class="red--text text--lighten-1 pt-2">
          Kurs wird in folgenden Studios verwendet: {{ deleteDialogPreText }}
        </v-card-text>
        <v-card-text class="pt-2">
          Möchtest du {{ getTextbyType(deleteDialogType) }}
          <strong>{{ shorten(deleteDialogTitle, 25) }}</strong>
          wirklich löschen?
        </v-card-text>
        <v-card-actions class="pa-4">
          <v-spacer></v-spacer>
          <v-btn text rounded @click="deleteDialog = false">Abbrechen</v-btn>
          <v-btn color="red lighten-1" rounded depressed dark @click="deleteEntry(dialogDeleteObj, deleteDialogType, 1)">
            <v-icon left small>mdi-delete-outline</v-icon>
            Löschen
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import api from "../../../api"
import userService from "../../../services/userService"
import CourseCategories from "./components/courseCategories.vue"
import Slim from "../../../plugins/slimImage/slim/slim.vue"
import EventHome from "../../event/eventHome.vue"

export default {
  name: "courseSettings",
  components: {
    CourseCategories,
    "slim-cropper": Slim,
    EventHome,
  },
  data() {
    return {
      userService,
      activeCourseIds: [],
      tab: 0,
      editIndex: null,
      courseList: [],
      courseListFilter: "",
      names: {
        endurance: "Ausdauer",
        strength: "Kraft",
        mobility: "Beweglichkeit",
        resilience: "Resilienz",
        coordination: "Koordination",
      },
      addCourse: {
        name: "",
        beschreibung: "",
        bild: "",
        slimMe: false,
        categories: {
          strength: 1,
          endurance: 1,
          mobility: 1,
          resilience: 1,
          coordination: 1,
        },
      },
      deleteDialog: false,
      deleteDialogText: "",
      deleteDialogTitle: "",
      dialogDeleteObj: {},
      deleteDialogType: "",
      deleteDialogPreText: "",
      slimOptionsExercise: {
        ratio: "16:9",
        initialImage: "/img/einmalig/imageUploadPlaceholder.jpg",
        buttonCancelLabel: "Abbrechen",
        buttonConfirmLabel: "Bestätigen",
        label: "Bild hochladen",
        labelLoading: "Bild wird hochgeladen",
        statusUploadSuccess: "gespeichert",
        service: this.uploadPicture,
        serviceFormat: "file",
        instantEdit: true,
        push: true,
      },
    }
  },
  async created() {
    await this.fetchCourseList()
    this.$emit("finishedloading")
  },
  computed: {
    filteredCourses() {
      let tempCourseList = this.courseList.filter((e) => this.activeCourseIds.includes(e._id))
      if (!this.courseListFilter) return tempCourseList
      return tempCourseList.filter((course) => course.name.toLowerCase().includes(this.courseListFilter.toLowerCase()))
    },
  },
  methods: {
    capitalize(str) {
      return this.names[str]
    },
    setEditIndex(active, index) {
      if (active) {
        this.editIndex = index
      } else {
        this.editIndex = null
      }
    },
    uploadPicture(formdata, progress, success, failure, slim) {
      const formData = new FormData()
      formData.append("file", formdata[0])

      let uploadimg = {}
      uploadimg.art = "groupFitness_course"
      uploadimg.formData = formData

      api
        .uploadImage(uploadimg)
        .then((data) => {
          if (data.status) {
            if (this.editIndex !== null) {
              this.courseList[this.editIndex].bild = data.name
            } else {
              this.addCourse.bild = data.name
            }
            success(data)
          }
        })
        .catch((error) => {
          failure(error)
        })
    },
    async createCourse(dialog) {
      const newCourse = await api.createGFCourse(this.addCourse)
      this.fetchCourseList()
      dialog.value = false
    },
    async updateCourse(course, dialog) {
      const updatedCourse = await api.updateGFCourse(course)
      const idx = this.courseList.findIndex((c) => c._id === course._id)
      if (idx !== -1) {
        this.$set(this.courseList, idx, course)
      }
      if (dialog) dialog.value = false
    },
    async saveCategories(course) {
      const updatedCourse = await api.updateGFCourse(course)
      const idx = this.courseList.findIndex((c) => c._id === course._id)
      if (idx !== -1) {
        this.$set(this.courseList, idx, course)
      }
      this.$toast.success("gespeichert")
    },
    async handleSaveCategories({ id, categories }) {
      const course = this.courseList.find((c) => c._id === id)
      if (course) {
        course.categories = { ...categories }
        await this.saveCategories(course)
      }
    },
    handleEditCourse(course) {
      // Zusätzliche Logik für den Editier-Button (optional)
    },
    async handleDeleteEntry(course) {
      this.deleteEntry(course, "course", 0)
    },
    getTextbyType(type) {
      if (type === "label") return "das Label"
      if (type === "room") return "den Raum"
      if (type === "course") return "den Kurs"
    },
    async deleteEntry(entry, type, status = 0) {
      this.dialogDeleteObj = entry
      this.deleteDialogType = type
      this.deleteDialogPreText = ""
      let error = false
      if (type === "label") this.deleteDialogTitle = entry.text
      if (type === "label" && status) await api.deleteGFLabel(entry._id).catch((e) => (error = true))
      if (type === "room") this.deleteDialogTitle = entry.name
      if (type === "room" && status) await api.deleteGFRoom(entry._id).catch((e) => (error = true))
      if (type === "course") this.deleteDialogTitle = entry.name
      if (type === "course") {
        let usage = await api.checkGFCourseUsage(entry._id)
        if (usage) this.deleteDialogPreText = usage
      }
      if (type === "course" && status) {
        await api.deleteGFCourse(entry._id)
        this.courseList = this.courseList.filter((c) => c._id !== entry._id)
      }
      if (!status) this.deleteDialog = true
      if (status && !error) this.deleteDialog = false
    },
    shorten(text, length = 25) {
      if (text && text.length > length) text = text.substr(0, length) + "..."
      return text
    },
    async fetchCourseList() {
      try {
        let activeCoureseids = await api.fetchActiveCourseIds()
        this.activeCourseIds = activeCoureseids
      } catch (e) {}
      let courses = await api.fetchGFCourses()
      courses = courses.map((course) => {
        if (!course.categories) {
          course.categories = {
            strength: 1,
            endurance: 1,
            mobility: 1,
            resilience: 1,
            coordination: 1,
          }
        }
        return course
      })
      this.courseList = courses
    },
  },
}
</script>

<style lang="scss" scoped>
::v-deep .v-slide-group__prev {
  display: none !important;
}

.courseSettings {
  &__tabs {
    ::v-deep .v-tab {
      text-transform: none;
      letter-spacing: 0.3px;
      font-weight: 600;
      font-size: 15px;
      transition: color 0.25s ease;
    }
    ::v-deep .v-tabs-slider {
      height: 3px;
      border-radius: 3px;
    }
  }

  &__search {
    ::v-deep .v-input__slot {
      background: rgba(255, 255, 255, 0.04) !important;
      transition: background 0.25s ease;
      &:hover {
        background: rgba(255, 255, 255, 0.07) !important;
      }
    }
  }

  &__action-add-btn {
    text-transform: none;
    letter-spacing: 0.3px;
    font-weight: 600;
    box-shadow: 0 6px 20px rgba(0, 0, 0, 0.35) !important;
    transition: transform 0.2s ease, box-shadow 0.2s ease;

    &:hover {
      transform: translateY(-1px);
      box-shadow: 0 10px 28px rgba(0, 0, 0, 0.45) !important;
    }
  }

  &__course {
    &-list {
      background: rgba(255, 255, 255, 0.03);
      border: 1px solid rgba(255, 255, 255, 0.06);
      border-radius: 14px;
      font-weight: 600;
      color: #fff;
      transition: background 0.25s ease, border-color 0.25s ease, transform 0.2s ease;

      &:hover {
        background: rgba(255, 255, 255, 0.06);
        border-color: rgba(255, 255, 255, 0.12);
        transform: translateY(-1px);
      }

      &-title {
        flex: 1;
        min-width: 0;
        span {
          white-space: nowrap;
          overflow: hidden;
          text-overflow: ellipsis;
        }
      }
    }
  }

  &__dialog-card {
    border-radius: 18px !important;
    overflow: hidden;

    ::v-deep .v-toolbar {
      border-radius: 0;
    }
  }

  &__dialog-content {
    background: transparent;
  }

  &__section-label {
    font-size: 12px;
    letter-spacing: 1.5px;
    text-transform: uppercase;
    color: rgba(255, 255, 255, 0.55);
    font-weight: 600;
    margin-bottom: 8px;
    margin-top: 4px;
  }

  &__cropper-wrap {
    border-radius: 14px;
    overflow: hidden;
    background: rgba(255, 255, 255, 0.03);
    border: 1px solid rgba(255, 255, 255, 0.06);
  }
}

/* List transitions */
.course-list-enter-active,
.course-list-leave-active {
  transition: all 0.3s ease;
}
.course-list-enter,
.course-list-leave-to {
  opacity: 0;
  transform: translateY(8px);
}

.action2 {
  display: flex;
  justify-content: center;
  flex-direction: column;
  margin-left: auto;
}

.course_picture {
  border-bottom: 1px solid rgba(255, 255, 255, 0.08);
  cursor: pointer;
  transition: background-color 0.25s ease;

  &:hover {
    background-color: rgba(255, 255, 255, 0.04);
  }
}
</style>
